import * as React from 'react'
import { UseFormSetValue } from 'react-hook-form'

import {
  SupportEventTakeCare as Presenter,
  IProps as IPresenter,
} from './presenter'

interface IProps
  extends Omit<
    IPresenter,
    'changeHandoverPersonHandler' | 'changeHandoverLocationHandler'
  > {
  setValue: UseFormSetValue<ICompleteReportFormStateStep2>
}

export const SupportEventTakeCare = ({
  index,
  setValue,
  ...props
}: IProps): JSX.Element => {
  const changeHandoverPersonHandler = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.value !== 'other') {
      setValue(`supportEvents.${index}.handoverPersonName`, undefined)
    }
  }
  const changeHandoverLocationHandler = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.value !== 'other') {
      setValue(`supportEvents.${index}.handoverLocationName`, undefined)
    }
  }

  return (
    <Presenter
      index={index}
      changeHandoverPersonHandler={changeHandoverPersonHandler}
      changeHandoverLocationHandler={changeHandoverLocationHandler}
      {...props}
    />
  )
}
